import FooterEmailAOld from './FooterEmailA';

export default function FooterEmailA({ theme, locale, TextA = {} }: { theme: string; locale: string; TextA: any }) {
    return (
        <div className="FooterEmailA">
            {(TextA.email_desc || TextA.email_title) && (
                <div className="FooterEmailA-info">
                    {TextA.email_title && <div className="FooterEmailA-title">{TextA.email_title}</div>}
                    {TextA.email_desc && <div className="FooterEmailA-desc">{TextA.email_desc}</div>}
                </div>
            )}
            <FooterEmailAOld theme={theme} needEmailAgree />
        </div>
    );
}
